// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-vTF","content":"styles_content__3_bl7","row":"styles_row__rNKs2","footer":"styles_footer__1tiKp","phraseLength":"styles_phraseLength__3vPaJ"};